
import ModalCodigo from "@/components/ModalCodigo.vue";
import { Component, Vue } from "vue-property-decorator";
import AppButton from "./AppButton.vue";

@Component({
  props: {
    title: String,
    click: Function,
    units: Array,
    checkedRadio: Number,
    openUnitFilter: Function,
    closeFilter: Function,
    showUnits: Object,
  },
  components: { ModalCodigo, AppButton },
})
export default class HeaderFilter extends Vue {
  canShow: any = { canShow: false };
  optionChecked: any = JSON.parse(sessionStorage.getItem("RENT_UNIT") || "{}");
  isChecked: any = () =>
    !!(
      JSON.parse(sessionStorage.getItem("RENT_UNIT") || "{}").id == "" ||
      JSON.parse(sessionStorage.getItem("RENT_UNIT") || "{}").id
    );

  mounted() {
    const self = this;
    if (!JSON.parse(sessionStorage.getItem("RENT_UNIT") || "{}").id) {
      this.$props.checkedRadio = -1;
    }
    this.canShow = this.$props.showUnits;
  }

  validateAnswer() {
    if (this.$props.checkedRadio != -1) {
      let unitChecked = this.$props.units.find(
        (el: any) => $("#unit-" + el.id).prop("checked") === true
      );
      if (unitChecked) {
        this.optionChecked = unitChecked;
        console.log(this.optionChecked);
        this.canShow.canShow = false;
        if (this.optionChecked)
          sessionStorage.setItem(
            "RENT_UNIT",
            JSON.stringify(this.optionChecked)
          );
        this.$emit("updatingRent");
      }
    }
  }
}
